/**
 * Calendar Preferences Service
 *
 * Service para gerenciar preferências de calendário do usuário
 */

import { api } from '@/lib/api';
import { UserCalendarPreferences } from '@troia-v3/types';

export const calendarPreferencesService = {
  /**
   * Buscar preferências de calendário do usuário
   */
  async getUserPreferences(): Promise<UserCalendarPreferences | null> {
    try {
      const response = await api.get('/users/me/preferences/calendar');
      return response.data.data;
    } catch (error: any) {
      // Se 404, usuário não tem preferências ainda (retornar null)
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },

  /**
   * Atualizar preferências de calendário do usuário
   */
  async updateUserPreferences(preferences: UserCalendarPreferences): Promise<UserCalendarPreferences> {
    const response = await api.put('/users/me/preferences/calendar', preferences);
    return response.data.data;
  },
};
